import { useTranslation } from 'react-i18next';
import { TextFieldPresets, UpdateWebhookId } from 'vopay';

type UpdateWebhookRows = {
  label: string;
  id: UpdateWebhookId;
  preset: keyof TextFieldPresets;
  type: 'url' | 'input';
  required: boolean;
};

const useBuildUpdateWebhookRows = (): UpdateWebhookRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Webhooks.Update.Form' });

  return [
    {
      label: t('transactionStatusWebHookURL', { defaultValue: 'Transaction Status' }),
      id: UpdateWebhookId.TransactionStatusWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('elinxStatusWebHookURL', { defaultValue: 'eLinx Status' }),
      id: UpdateWebhookId.ElinxStatusWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('accountStatusWebHookURL', { defaultValue: 'Account Status' }),
      id: UpdateWebhookId.AccountStatusWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('batchRequestWebHookURL', { defaultValue: 'Batch Requests' }),
      id: UpdateWebhookId.BatchRequestWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('bankAccountCreationWebHookURL', { defaultValue: 'Bank Account Creation' }),
      id: UpdateWebhookId.BankAccountCreationWebHookURL,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('batchDetailWebhookUrl', { defaultValue: 'Batch Detail' }),
      id: UpdateWebhookId.BatchDetailWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('scheduledTransactionsWebhookUrl', { defaultValue: 'Scheduled Transaction' }),
      id: UpdateWebhookId.ScheduledTransactionsWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('accountVerificationsWebhookUrl', { defaultValue: 'Account Verification' }),
      id: UpdateWebhookId.AccountVerificationsWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('transactionGroupWebhookUrl', { defaultValue: 'Transaction Group' }),
      id: UpdateWebhookId.TransactionGroupWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('accountBalanceWebhookUrl', { defaultValue: 'Account Balance' }),
      id: UpdateWebhookId.AccountBalanceWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('clientAccountBalanceWebhookUrl', { defaultValue: 'Client Account Balance' }),
      id: UpdateWebhookId.ClientAccountBalanceWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('paymentReceivedWebhookUrl', { defaultValue: 'Payment Received' }),
      id: UpdateWebhookId.PaymentReceivedWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('accountLimitWebhookUrl', { defaultValue: 'Account Limit' }),
      id: UpdateWebhookId.AccountLimitWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('virtualTransactionWebhookUrl', { defaultValue: 'Virtual Accounts' }),
      id: UpdateWebhookId.VirtualTransactionWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('creditCardConnectionWebhookUrl', { defaultValue: 'Credit Card Connection' }),
      id: UpdateWebhookId.CreditCardConnectionWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
    {
      label: t('debitCardConnectionWebhookUrl', { defaultValue: 'Debit Card Connection' }),
      id: UpdateWebhookId.DebitCardConnectionWebhookUrl,
      preset: 'text',
      type: 'url',
      required: true,
    },
  ];
};

export default useBuildUpdateWebhookRows;
